import { ChebyshevCoefficients } from '@ootk/src/interpolator/ChebyshevCoefficients';
import { Seconds } from '@ootk/src/main';

export const charonChebyshevCoeffs: ChebyshevCoefficients[] = [
  new ChebyshevCoefficients(
    631152000 as Seconds,
    788940000 as Seconds,
    new Float64Array([
      -5276162186.84657, 356418192.19335622, 6459221.2467386406, -143960.47585775057, -7826.9568801720934, 1350.8066811402639, -368.87109360694888, -432.22973216374714,
      35.626482534408566, 140.78025099436442, 32.233469438552859, -31.68403878211975,
    ]),
    new Float64Array([
      -7097000913.3884192, -263088928.25056833, 8336410.2970068296, 141114.88676900865, -285.37156109809877, -40.700075387954712, -477.93237913449605, -322.08427136739095,
      46.722798220316569, 109.13016284306843, 44.317725658416748, -23.516902494430543,
    ]),
    new Float64Array([
      -625257092.84370327, -189562426.04941487, 714403.31267791986, 104847.7709439834, 1313.9387638191381, -3444.4232199688754, -345.41635166903336, 1177.7874914591512,
      33.211174969871841, -400.76142836511133, 31.589278632899124, 87.257075592875481,
    ])
  ),
  new ChebyshevCoefficients(
    788940000 as Seconds,
    946728000 as Seconds,
    new Float64Array([
      -3760854576.1918283, 399232579.00627691, 4074291.0267744698, -223531.71468318303, 9931.4842275619503, 1524.6459003130594, -860.98554881413781, 521.33388977050777,
      69.998493639628094, -209.39694504737852, 51.791503461201984, 44.67883950869242,
    ]),
    new Float64Array([
      -8007371590.3468714, -191227812.16021228, 9346952.3396761734, -8592.0822388331089, -9116.897370656332, 297.65690997441607, -587.27835016250606, 700.01061944961543,
      68.358165740966797, -267.77058200836183, 50.824588871002199, 53.485783290863033,
    ]),
    new Float64Array([
      -1365394886.0816746, -179741731.29415354, 1633488.7656720856, 49894.667767361796, -1374.8377356012661, -830.24172887007398, -110.1635340531667, 742.01366179585455,
      -1.0786528984705608, -294.16351503928502, -17.216344996293387, 50.288729381561282,
    ])
  ),
  new ChebyshevCoefficients(
    946728000 as Seconds,
    1104516000 as Seconds,
    new Float64Array([
      -2111172425.6272213, 424258776.43659842, 2402086.6529209218, -115811.56024817626, -5828.4078668355942, -6.5604922612508139, 375.51020065148668, 549.00759137471516,
      -22.69856203397115, -262.293311325709, -13.352301359176636, 39.036915890375774,
    ]),
    new Float64Array([
      -8624663995.6228447, -117651149.54831269, 9102223.4994626846, 11313.454684654871, 5570.7065619786581, -341.45295325915021, 281.33609906832379, 426.1606644789378,
      -39.67923847834269, -191.07602456410726, -29.686811447143555, 28.442226934432984,
    ]),
    new Float64Array([
      -2055240038.6040556, -164817838.45391032, 2099242.140350922, 60330.735171794891, 4164.2412735144298, -670.32183102766669, 867.14983164072032, -187.72579273382823,
      -107.29468426307042, 89.831920480728144, -86.73012761274974, -14.351137022177378,
    ])
  ),
  new ChebyshevCoefficients(
    1104516000 as Seconds,
    1262304000 as Seconds,
    new Float64Array([
      -386476273.84507954, 436491597.78375554, 476520.9967928211, -212147.8928295334, -5182.3377614378933, 694.11797875960667, 1074.1428702354431, 444.05991162459054,
      -91.251389809449506, -156.44063074191411, -66.071243826548255, 37.424680626392366,
    ]),
    new Float64Array([
      -8947993844.8825283, -43854123.120885275, 9252592.1676073708, -37066.035375754036, -11939.252973906199, -627.49572649002073, 840.47251920700069, 216.34853947957356,
      -77.319804382324222, -69.626267401377362, -63.411939748128255, 17.752638610204059,
    ]),
    new Float64Array([
      -2676104728.9798069, -145038437.83964837, 2776988.9465060951, 37068.661461146672, 581.04947642485297, 836.65869014263149, -623.53048082192743, -939.37468469937642,
      40.674729299545291, 367.6352774858475, 9.6356364806493122, -68.256219379107151,
    ])
  ),
  new ChebyshevCoefficients(
    1262304000 as Seconds,
    1420092000 as Seconds,
    new Float64Array([
      1353067781.0747781, 431720337.03440851, -1374241.1565994611, -67997.433231349787, 6019.3385481387377, -668.04252409438288, 287.97333628137903, -541.43154233495397,
      -31.534017244974773, 206.96459248562653, -31.005594065785406, -42.339328319827715,
    ]),
    new Float64Array([
      -8981638082.4496002, 26012740.898263805, 8066111.5255868277, -112190.77629518509, 8510.4884276707962, 2793.6819736480711, -49.628365675608315, -894.0807653109232,
      -15.976012325286865, 312.38574972152708, -23.163551998138427, -64.843504810333258,
    ]),
    new Float64Array([
      -3210424880.305964, -122067015.34498155, 2856510.1404107809, -8634.8923168102901, 6238.1074223121004, 2575.5309561570484, -614.37360451221468, -845.05633514722183,
      44.646279978752133, 286.68811598618822, 38.662087559700012, -62.018593279520672,
    ])
  ),
  new ChebyshevCoefficients(
    1420092000 as Seconds,
    1577880000 as Seconds,
    new Float64Array([
      3052929517.1316743, 417471209.96291292, -2286080.5363077084, -119185.21295115152, -9052.4489990870152, 1348.6450795173646, 301.46158277988434, -955.07127380371094,
      -8.2720167160034173, 372.03849055767057, 4.5475298206011452, -69.952163855234787,
    ]),
    new Float64Array([
      -8753679501.1067276, 87470771.104457766, 7432319.4875312801, -42279.653894869487, -6256.8319710731503, 159.19842875798543, 118.79778776168823, -594.88948904673259,
      4.2414884567260742, 231.79319464365642, 15.445681635538737, -41.266037480036417,
    ]),
    new Float64Array([
      -3651796342.9838085, -98403292.071317539, 3084322.15450902, 13590.490275375048, 937.69345544179282, -598.30219440460201, -998.38456562360125, 648.67554259300232,
      94.678636074066162, -238.57335993448893, 73.164488895734152, 53.581537071863806,
    ])
  ),
  new ChebyshevCoefficients(
    1577880000 as Seconds,
    1735668000 as Seconds,
    new Float64Array([
      4676001951.66959, 392761287.21658194, -3803008.6269407589, -72729.109684769312, 14561.726772149404, 498.13030761082968, -1146.235198966662, -235.15560609499613,
      99.845288125673932, 84.951623161633805, 75.346457290649411, -18.199887267748515,
    ]),
    new Float64Array([
      -8290659840.7283068, 143069030.75661036, 6260116.4342048485, -158590.79860774675, -2385.3636381785072, 2118.307670243581, -800.32981049219768, -109.11110302607219,
      99.488333288828528, 29.472252273559569, 83.533621629079178, -4.6083526770273844,
    ]),
    new Float64Array([
      -3995610726.0159721, -73539258.251041636, 3017846.9407150028, -48868.097796765964, -1931.7985551834106, 1821.1168839931488, 37.094806734720862, 825.00215041637421,
      1.0770710547765097, -382.06409461498259, 3.0239280144373577, 61.19914037386576,
    ])
  ),
  new ChebyshevCoefficients(
    1735668000 as Seconds,
    1893456000 as Seconds,
    new Float64Array([
      6184307123.5755768, 361314806.97624689, -3944367.0380612849, -14914.518756373724, -9490.9852455774944, -744.14168670972185, 162.90557797749838, 486.15205526351929,
      7.4148245334625242, -202.93337642351787, 19.38453826904297, 33.421558984120686,
    ]),
    new Float64Array([
      -7628148023.2685375, 187151395.70967451, 5024158.3242367106, -39381.589873218538, -20.727196900049844, -1916.9335279782613, 133.80813285509745, 808.76645657221479,
      7.8265585104624433, -317.51759475072225, 24.597650877634685, 56.439996735254923,
    ]),
    new Float64Array([
      -4243633027.6805048, -50632779.238632709, 2808368.1292743525, -1955.9478522698084, -3299.6302604993184, -894.27090450922651, 1327.6886550903321, 770.8311522563298,
      -120.93583676815032, -287.35533094406128, -86.889158137639356, 61.22337794303894,
    ])
  ),
  new ChebyshevCoefficients(
    1893456000 as Seconds,
    2051244000 as Seconds,
    new Float64Array([
      7562568346.614665, 327155399.8100397, -4709870.9382289248, -76890.932255522406, 3376.2243927796681, -566.80143731435135, 269.21281015078227, 858.47816173235572,
      -22.837161159515382, -301.60407363573711, -16.319446039199828, 65.964678764343262,
    ]),
    new Float64Array([
      -6802803627.9277306, 224958809.0597735, 4330836.1562211514, -99836.49962008794, -10841.553531646729, -1963.0590172926584, 385.85798552831011, 817.3166229724884,
      -15.886999162038167, -270.57434439659119, -12.649981673558553, 60.528512652715044,
    ]),
    new Float64Array([
      -4401260698.3847675, -28192600.754562996, 2769499.413801495, -31104.880838712055, -7723.7744405269623, 1681.644481420517, 698.76969052155812, -780.26490963300068,
      -52.9683940966924, 279.83350347677867, -49.796393458048499, -57.764319682121275,
    ])
  ),
  new ChebyshevCoefficients(
    2051244000 as Seconds,
    2209032000 as Seconds,
    new Float64Array([
      8793241672.5781097, 288146771.07890594, -4757124.5343115488, 59349.369702959062, -3661.1787479718528, -1792.6800377209981, 887.48559075991307, 40.004408884048459,
      -79.0658365726471, -23.578680928548177, -61.733837556838985, -3.399471139907837,
    ]),
    new Float64Array([
      -5843238416.57551, 253598695.6271033, 2928746.4672525884, -53868.564889431, 9948.7418261845905, -1112.3019846439361, 479.1935664017995, -2.3666896502176922,
      -65.172828531265253, 2.5216672579447428, -55.912471818923947, -6.808543888727824,
    ]),
    new Float64Array([
      -4472813063.8805723, -7956823.6200205646, 2346208.2385672093, -13479.51053331693, -890.95684618949883, 1092.319460662206, 669.89097525278726, -1242.9632078965506,
      -47.810984563827517, 481.23650345802304, -18.508993117014565, -92.756579089164731,
    ])
  ),
  new ChebyshevCoefficients(
    2209032000 as Seconds,
    2366820000 as Seconds,
    new Float64Array([
      9871408640.5534496, 250923808.82804808, -4758781.0692216558, -47347.69321848551, -4877.218404483795, -130.94356460571288, 660.79857031504309, -452.25634225209552,
      -63.104908911387128, 219.62126178741454, -49.859451770782471, -32.360745429992676,
    ]),
    new Float64Array([
      -4784317712.2038908, 275606506.84813547, 2605577.3411258855, -27242.947239987054, -5894.2510110060375, -1316.000693877538, 388.73369646072388, -603.05233019193008,
      -41.915159940719604, 274.58243403434756, -36.704843044281006, -44.502665440241493,
    ]),
    new Float64Array([
      -4467592405.0388451, 10560231.984256204, 2329949.5905484678, 676.01956613858545, -3609.2488770802815, -690.54540545145665, -1113.1133948961894, -520.24823180834449,
      128.79948304494221, 230.92849985758463, 103.14182774225871, -38.499216890335084,
    ])
  ),
  new ChebyshevCoefficients(
    2366820000 as Seconds,
    2493072000 as Seconds,
    new Float64Array([
      10713899936.004417, 171790803.2383751, -3335748.074992911, 12620.292177772522, 6664.9544258117676, 481.17801561355589, 381.5045948982239, -45.244178136189781,
      -168.16828428904216, -39.868245347340903, 17.916430187225341, 15.825502268473308,
    ]),
    new Float64Array([
      -3763537692.6812115, 233317898.54526213, 1039407.0017824173, -64300.944410506883, 2783.8753105243045, 1330.8317537546159, 338.06281467278797, -51.065660993258156,
      -124.17786049048105, -34.267905966440836, 15.241284370422363, 13.602995268503825,
    ]),
    new Float64Array([
      -4402264538.7224846, 21070285.414646767, 1271938.984501489, -19563.163277832668, 1036.1551671822865, 499.30199818611146, -609.66238128344219, -32.585472218195598,
      200.47048686345417, -41.484130239486696, -20.905631629625955, 16.009423915545145,
    ])
  ),
];
